export const isRecord = (x) => typeof x === "object" && x !== null && x.constructor.name === "Object";
